<template>
  <header
    class="pt-nav relative h-screen min-h-[22rem] overflow-hidden bg-amber-100 lg:overflow-visible"
  >
    <ClientOnly>
      <Vue3Lottie
        :animation-link="data.lottie.url"
        :renderer-settings="{
          preserveAspectRatio: 'xMaxYMid meet',
        }"
        class="lottie-home pointer-events-none overflow-hidden"
      />
    </ClientOnly>

    <Container class="lg:pb-25 absolute inset-x-0 bottom-0 pb-28">
      <p
        class="mb-4 text-3xs font-semibold uppercase text-blue-500 md:text-2xs"
      >
        {{ data.subtitle }}
      </p>
      <h1 class="max-w-6xl text-xl font-medium md:text-5xl">
        {{ data.heading }}
      </h1>
    </Container>

    <Floater :link="data.link" :link-text="data.link_text" />

    <ScrollDownIndicator class="absolute inset-x-0 bottom-0 hidden lg:block" />
  </header>
</template>

<script setup>
defineProps({
  data: {
    type: Object,
    required: true,
  },
})
</script>

<style>
.lottie-home svg {
  height: 58vh !important;
  transform: scale(1.6) !important;
  transform-origin: 75% 67%;

  @screen xs {
    transform-origin: 90% 45%;
  }

  @screen lg {
    transform: scale(1);
    height: 70vh !important;
    transform-origin: 91% 55%;
  }

  @screen 2xl {
    height: 100vh !important;
    transform-origin: 85% 70%;
    transform: scale(1.4) !important;
  }

  @screen 3xl {
    height: 114vh !important;
    transform-origin: 100% 57%;
    transform: scale(1.6) !important;
  }
}
</style>
